import React from 'react'
import get from 'lodash/get'

import { LoggedInSmallHeader } from 'components/Header/LoggedIn/Small'
import { LoggedInLargeHeader } from 'components/Header/LoggedIn/Large'
import { LoggedOutSmallHeader } from 'components/Header/LoggedOut/Small'
import { LoggedOutLargeHeader } from 'components/Header/LoggedOut/Large'

export const Header = ({ domain, loggedIn, viewer, site, show, handleNavClick }) => {
  const altTag = get(site, 'name')
  const largeLogo = get(site, 'fullLogoImageSource')
  const smallLogo = get(site, 'fullLogoMobileImageSource')
  const startedCta = get(site, 'assets.startedCta')
  const rightNavigationItems = get(site, 'navigation.footer.navigation_items')
  const siteNavigationItems = get(site, 'navigation.navigation_items.navigation_items')

  if (loggedIn && viewer) {
    const loggedInNavigationItems = get(viewer, 'navigation.navigation_items')
    const title = get(viewer, 'drop_down.title')
    const profileLink = get(viewer, 'drop_down.link')
    const profileNavigationItems = get(viewer, 'drop_down.navigation_items')
    return (
      <>
        <LoggedInLargeHeader
          altTag={altTag}
          logo={largeLogo}
          loggedInNavigationItems={loggedInNavigationItems}
          title={title}
          profileLink={profileLink}
          profileNavigationItems={profileNavigationItems}
        />
        <LoggedInSmallHeader
          altTag={altTag}
          logo={smallLogo}
          loggedInNavigationItems={loggedInNavigationItems}
          profileNavigationItems={profileNavigationItems}
          handleNavClick={handleNavClick}
          show={show}
        />
      </>
    )
  }
  return (
    <>
      <LoggedOutLargeHeader
        domain={domain}
        altTag={altTag}
        logo={largeLogo}
        siteNavigationItems={siteNavigationItems}
        rightNavigationItems={rightNavigationItems}
        startedCta={startedCta}
      />
      <LoggedOutSmallHeader
        altTag={altTag}
        logo={smallLogo}
        show={show}
        handleNavClick={handleNavClick}
        siteNavigationItems={siteNavigationItems}
        startedCta={startedCta}
      />
    </>
  )
}
